import * as Sentry from "@sentry/react";

const CATEGORY = "recording";

/**
 * Sentry helpers for the Socratic recording lifecycle. Breadcrumbs build the
 * trail that gives any later issue context; warnings are the alertable signal
 * that a recording captured or submitted without the expected audio/video.
 *
 * Session Replay masks media (`blockAllMedia`), so these are the only window
 * into why a recording came out degraded.
 */
export function recordingBreadcrumb(
  message: string,
  data?: Record<string, unknown>
): void {
  Sentry.addBreadcrumb({ category: CATEGORY, level: "info", message, data });
}

export function captureRecordingWarning(
  message: string,
  tags: Record<string, string | number | boolean>,
  extra: Record<string, unknown>
): void {
  Sentry.captureMessage(message, { level: "warning", tags, extra });
}

/**
 * Report a recording upload failure as an exception — unlike a degraded-but-
 * submitted recording, this blocks the student from submitting, so it carries
 * the underlying error alongside the context needed to tell connection drops
 * apart from S3/API failures.
 */
export function captureRecordingError(
  error: unknown,
  tags: Record<string, string | number | boolean>,
  extra: Record<string, unknown>
): void {
  Sentry.captureException(error, { level: "error", tags, extra });
}
